import { Building2, User } from 'lucide-react'
import { useAppMode, useDevModeOverride, useHasBusinessAccess, useSetAppMode } from '../../stores/appStore'

export function ModeSwitcher({ collapsed }: { collapsed?: boolean }) {
  const mode = useAppMode()
  const setMode = useSetAppMode()
  const hasBusinessAccess = useHasBusinessAccess()
  const devModeOverride = useDevModeOverride()

  if (devModeOverride === 'individual' || devModeOverride === 'business') return null
  if (!hasBusinessAccess) return null
  if (collapsed) return null

  return (
    <div
      style={{
        display: 'flex',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '8px',
        padding: '4px',
        marginBottom: '1.5rem',
      }}
      role="tablist"
      aria-label="Switch between individual and business mode"
    >
      <button
        onClick={() => setMode('individual')}
        role="tab"
        aria-selected={mode === 'individual'}
        style={{
          flex: 1, padding: '0.5rem', borderRadius: '6px', border: 'none',
          background: mode === 'individual' ? 'var(--primary)' : 'transparent',
          color: mode === 'individual' ? 'white' : '#9ca3af',
          fontSize: '0.75rem', fontWeight: '500', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.35rem',
          transition: 'all 0.2s',
        }}
      >
        <User size={14} aria-hidden="true" />
        Individual
      </button>
      <button
        onClick={() => setMode('business')}
        role="tab"
        aria-selected={mode === 'business'}
        style={{
          flex: 1, padding: '0.5rem', borderRadius: '6px', border: 'none',
          background: mode === 'business' ? 'var(--primary)' : 'transparent',
          color: mode === 'business' ? 'white' : '#9ca3af',
          fontSize: '0.75rem', fontWeight: '500', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.35rem',
          transition: 'all 0.2s',
        }}
      >
        <Building2 size={14} aria-hidden="true" />
        Business
      </button>
    </div>
  )
}

